export function getLifecycleState(item = {}) {
  const isArchived = !!item.archived_at;
  const isAnonymized = item.status === 'anonymized' || !!item.anonymized_at;
  const isInactive = item.status === 'inactive';
  const isUnenrolled = item.status === 'unenrolled';

  const isStudentLifecycle = 'customer_student_number' in item || item.status === 'unenrolled';

  const isActive = !isInactive && !isUnenrolled && !isArchived && !isAnonymized;

  return {
    isActive,
    isInactive,
    isUnenrolled,
    isArchived,
    isAnonymized,
    isStudentLifecycle,

    // ouders/docenten
    showDeactivate: !isStudentLifecycle && isActive,
    showReactivate: !isStudentLifecycle && isInactive && !isArchived && !isAnonymized,

    // leerlingen
    showUnenroll: isStudentLifecycle && isActive,
    showReenroll: isStudentLifecycle && isUnenrolled && !isArchived && !isAnonymized,

    // gedeeld
    showArchive:
      !isAnonymized &&
      !isArchived &&
      ((isStudentLifecycle && isUnenrolled) || (!isStudentLifecycle && isInactive)),

    showAnonymize: isArchived && !isAnonymized
  };
}

export function getStatusBadgeInfo(item = {}) {
  const {
    isActive,
    isInactive,
    isUnenrolled,
    isArchived,
    isAnonymized,
    isStudentLifecycle
  } = getLifecycleState(item);

  if (isAnonymized) {
    return {
      label: 'Geanonimiseerd',
      className: 'badge bg-danger'
    };
  }

  if (isStudentLifecycle && isArchived && isUnenrolled) {
    return {
      label: 'Uitgeschreven + Gearchiveerd',
      className: 'badge bg-secondary'
    };
  }

  if (!isStudentLifecycle && isArchived && isInactive) {
    return {
      label: 'Inactief + Gearchiveerd',
      className: 'badge bg-secondary'
    };
  }

  if (isArchived) {
    return {
      label: 'Gearchiveerd',
      className: 'badge bg-secondary'
    };
  }

  if (isUnenrolled) {
    return {
      label: 'Uitgeschreven',
      className: 'badge bg-warning text-dark'
    };
  }

  if (isInactive) {
    return {
      label: 'Inactief',
      className: 'badge bg-warning text-dark'
    };
  }

  if (isActive) {
    return {
      label: 'Actief',
      className: 'badge bg-success'
    };
  }

  return {
    label: 'Onbekend',
    className: 'badge bg-light text-dark'
  };
}